import React from 'react';
import './styles.scss';

import useReactRouter from 'use-react-router';

const NotFound: React.FC = () => {
  const { history } = useReactRouter();
  return (
    <div className="notFound">
      <h1>Pagina não encontrada!</h1>
      <button onClick={() => history.push('/')} className="goBackBtn">
        Voltar para o início
      </button>
    </div>
  );
};

export default NotFound;
